module.exports = __webpack_public_path__ + "img/failure@2x.600d78d8.png";